import TramyNews1 from "../assets/img/tramy_news_1.svg";
import TramyNews2 from "../assets/img/tramy_news_2.svg";
import TramyNews3 from "../assets/img/tramy_news_3.svg";

export const blogArray = [
  {
    image: TramyNews1,
    title: "¿Qué es el comercio conversacional?",
    link: "https://tramy.substack.com/p/comercio-conversacional",
  },
  {
    image: TramyNews2,
    title: "¿Cómo integrar la API de WhatsApp a tu negocio?",
    link: "https://tramy.substack.com/p/intregar-api-whatsapp",
  },
  {
    image: TramyNews3,
    title: "Razones para apostar por el comercio conversacional",
    link: "https://tramy.substack.com/p/tramy",
  },
];

export const tutorialDescription =
  "En este video podrás visualizar las principales funcionalidades de tramy para tu empresa.";

export const analyticsHeaders = [
  "Agente",
  "Última actividad",
  "Actividades de hoy",
  "Contactos asignados",
  "Contactos abiertos",
  "Ranking",
];
